'use strict';

function CompanyGuestFoldersCtrl() {
}

angular.module('dokiv')
  .controller('CompanyGuestFoldersCtrl', [CompanyGuestFoldersCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/folders/CompanyGuestFoldersCtrl.js
// module id = 290
// module chunks = 0